export function SkeletonLine({ width = 'w-full', height = 'h-3', className = '' }) {
  return (
    <div className={`bg-[#E5E7EB] rounded-[6px] animate-pulse ${width} ${height} ${className}`} />
  );
}

export function SkeletonCard({ rows = 3, className = '' }) {
  return (
    <div className={`bg-white rounded-[12px] border border-[#E5E7EB] p-5 space-y-3 ${className}`}>
      <SkeletonLine width="w-1/3" height="h-3.5" />
      {Array.from({ length: rows - 1 }).map((_, i) => (
        <SkeletonLine key={i} width={i % 2 === 0 ? 'w-full' : 'w-2/3'} />
      ))}
    </div>
  );
}

export function SkeletonList({ count = 4, className = '' }) {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} rows={3} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4, className = '' }) {
  return (
    <div className={`bg-white rounded-[12px] border border-[#E5E7EB] overflow-hidden ${className}`}>
      <div className="bg-surface border-b border-[#E5E7EB] px-4 py-2.5 flex gap-6">
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonLine key={i} width={i === 0 ? 'w-24' : 'w-16'} height="h-2.5" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="px-4 py-3 border-b border-[#F3F4F6] flex gap-6 items-center">
          {Array.from({ length: cols }).map((_, j) => (
            <SkeletonLine key={j} width={j === 0 ? 'w-32' : j === cols - 1 ? 'w-12' : 'w-20'} />
          ))}
        </div>
      ))}
    </div>
  );
}
